// Compute upright, collision-avoided element labels with level-of-detail.
// Labels keep a constant on-screen size (world footprint = screen size / zoom).
// A label shows its NAME only when the element is large enough on screen
// (LOD); smaller elements are shown as a compact category dot instead.
const NAME_MIN_SCREEN = 26; // px: element on-screen max dimension to show its name
const charW = 6.4;

export function computeLabelLayout(elements, ppm, showConsumption, showConsumptionNight, showLabelsOnly, zoom, nameMin = NAME_MIN_SCREEN) {
  const z = zoom || 1;
  const labels = elements
    .filter((el) => el.kind !== "fence" && el.kind !== "guard")
    .map((el) => {
      const wpx = el.length * ppm, hpx = el.width * ppm;
      const cx = el.x + wpx / 2, cy = el.y + hpx / 2;
      const showKw = showConsumption && !showLabelsOnly;
      const showKwNight = showConsumptionNight && !showLabelsOnly;
      const nameW = (el.name ? el.name.length : 1) * charW;
      const kwW = showKw ? (String(el.consumption).length + 3) * charW : 0;
      const kwNightW = showKwNight ? (String(el.consumption_night || 0).length + 5) * charW : 0;
      const wScreen = Math.max(nameW, kwW, kwNightW) + 12;
      const lines = 1 + (showKw ? 1 : 0) + (showKwNight ? 1 : 0);
      const hScreen = lines * 13 + 4;
      const named = Math.max(wpx, hpx) * z >= nameMin;
      return {
        id: el.id, categoryId: el.category_id, anchorX: cx, anchorY: cy, x: cx, y: cy,
        w: wScreen / z, h: hScreen / z, text: el.name, named,
        showKw, consumption: el.consumption, showKwNight, consumptionNight: el.consumption_night || 0,
      };
    });
  // collision avoidance only among labels that actually show their name
  const named = labels.filter((l) => l.named);
  const overlap = (a, b) =>
    Math.abs(a.x - b.x) * 2 < (a.w + b.w) && Math.abs(a.y - b.y) * 2 < (a.h + b.h);
  for (let iter = 0; iter < 60; iter++) {
    let any = false;
    for (let i = 0; i < named.length; i++) {
      for (let j = i + 1; j < named.length; j++) {
        const a = named[i], b = named[j];
        if (overlap(a, b)) {
          any = true;
          const need = (a.h + b.h) / 2 - Math.abs(a.y - b.y) + 1 / z;
          const dir = a.y <= b.y ? -1 : 1;
          a.y += (dir * need) / 2;
          b.y -= (dir * need) / 2;
        }
      }
    }
    if (!any) break;
  }
  return labels;
}
